const defaultGetValue = (entry) => Number(entry?.value);

const defaultGetKey = (entry) => {
  const id = entry?.player?.id;
  return id == null ? null : String(id);
};

export function splitRankingHalves(
  entries,
  {
    getValue = defaultGetValue,
    getKey = defaultGetKey,
    expanded = false,
    collapsedLimit = 3,
  } = {}
) {
  const sortedDesc = [...(entries || [])].sort((a, b) => getValue(b) - getValue(a));
  const topCount = Math.ceil(sortedDesc.length / 2);
  const topHalf = sortedDesc.slice(0, topCount);
  const topKeys = new Set(topHalf.map(getKey).filter((key) => key != null));
  const lowestHalf = sortedDesc
    .slice(topCount)
    .filter((entry) => {
      const key = getKey(entry);
      return key == null || !topKeys.has(key);
    })
    .sort((a, b) => getValue(a) - getValue(b));
  const limit = Math.max(0, collapsedLimit);

  return {
    sortedDesc,
    sortedAsc: [...sortedDesc].sort((a, b) => getValue(a) - getValue(b)),
    topHalf,
    lowestHalf,
    topVisible: expanded ? topHalf : topHalf.slice(0, limit),
    lowestVisible: expanded ? lowestHalf : lowestHalf.slice(0, limit),
    hasHiddenEntries: topHalf.length > limit || lowestHalf.length > limit,
  };
}
